module.exports = __webpack_public_path__ + "img/marito.06c43f0a.png";